<template>
  <IDEDialog
    title="新建文件"
    width="400px"
    :visible="visible"
    @confirm="confirm"
    @close="close"
  >
    <el-form ref="form" :model="form" :rules="rules">
      <el-form-item prop="name">
        <InputItem label="文件名" :required="true">
          <el-input v-model="form.name" @input="handleNameInput"/>
        </InputItem>
      </el-form-item>
      <el-form-item prop="fileNameExp">
        <InputItem label="文件输出名称表达式" :required="true">
          <el-input v-model="form.fileNameExp"/>
        </InputItem>
      </el-form-item>
      <el-form-item prop="alias">
        <InputItem label="文件别名" :required="true">
          <el-input v-model="form.alias"/>
        </InputItem>
      </el-form-item>
      <el-form-item prop="cycle">
        <InputItem label="构建周期" :required="true">
          <el-select v-model="form.cycle">
            <el-option label="一次性构建" value="ONCE"/>
            <el-option label="模块构建" value="MODULE"/>
          </el-select>
        </InputItem>
      </el-form-item>
      <el-form-item prop="enableExp">
        <InputItem label="启用逻辑">
          <el-input type="textarea" v-model="form.enableExp" placeholder="表达式返回true字符串表示启用"/>
        </InputItem>
      </el-form-item>
    </el-form>
  </IDEDialog>
</template>

<script>
import IDEDialog from '../IDEDialog'
import InputItem from './InputItem'
import FileMixin from './FileMixin'
import { saveFile } from '@/api/template/file'
import { buildNewFile } from '../utils'

export default {
  name: 'OperaFileDialog',
  mixins: [FileMixin],
  components: { InputItem, IDEDialog },
  props: {
    // 模版ID
    templateId: {},
    // 模版文件
    templateFiles: {}
  },
  data () {
    return {
      visible: false,
      file: null,
      folder: null,
      form: {
        id: null,
        name: '',
        alias: '',
        templateId: this.templateId,
        fileNameExp: '',
        outputPath: null,
        viewType: 'CODE',
        enableExp: '',
        cycle: 'ONCE'
      },
      rules: {
        name: [
          { required: true, message: '请输入文件名称' }
        ]
      }
    }
  },
  methods: {
    // 打开窗口
    open (file, folder) {
      this.visible = true
      this.file = file
      this.folder = folder
      // 编辑
      if (file != null) {
        this.$nextTick(() => {
          for (const key in this.form) {
            this.form[key] = file[key]
          }
        })
      }
      // 新建
      if (file == null) {
        this.$nextTick(() => {
          this.$refs.form.resetFields()
        })
        this.form.id = null
        this.form.outputPath = folder.path
        this.form.cycle = folder.cycle
      }
    },
    // 关闭窗口
    close () {
      this.visible = false
    },
    // 确认
    confirm () {
      // const file = buildNewFile(this.form)
      saveFile(this.form)
        .then(data => {
          this.form.id = data.id
          // 新建
          if (this.file == null) {
            this.$emit('create-success', { file: this.form, folder: this.folder })
          }
          // 编辑
          if (this.file != null) {
            Object.assign(this.file, this.form)
          }
          this.close()
        })
        .catch(e => {
          this.$tip.apiFailed(e)
        })
    },
    // 处理名称输入
    handleNameInput () {
      this.__syncFileInfo(this.form)
    }
  }
}
</script>

<style scoped>

</style>
